import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DisplayPdfDialogComponent } from './components/display-pdf-dialog/display-pdf-dialog.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrl: './upload-file.component.scss',
})
export class UploadFileComponent {
  @Input() class: string;
  @Input() label: string;
  @Input() multiple = false;
  @Input() isDeletable = true;
  @Input() hasDropDown = false;
  @Input() hasSecDropDown = false;
  @Input() required = false;
  @Input() options2: any[];
  @Input() parentForm: FormGroup;
  @Input() secParentForm: FormGroup;
  @Input() options: any[];
  @Output() sendFile = new EventEmitter<any>();
  @Output() sendFileWithId = new EventEmitter<any>();

  @Output() deleteFile = new EventEmitter<any>();
  @Input() fileName: string;
  type: string;
  errorMsg: string;
  url: string | ArrayBuffer | null | undefined;
  file: File | undefined;
  @Input() files: any[] = [];
  listFiles: any[] = [];
  constructor(private dialog: MatDialog) {}

  @ViewChild('fileUpload', { static: false }) fileInput: ElementRef;

  openDisplayPdf(url?: any, file?: File) {
    if (file && url) {
      const dialog = this.dialog.open(DisplayPdfDialogComponent, {
        data: {
          file,
          src: url,
        },
        width: file?.type?.includes('pdf') ? '80vw' : 'auto',
      });
    }
  }

  onFileSelected(event: any) {
    this.errorMsg = '';
    const files = Array.from(event.target.files);

    if (event.target.files.length) {
      files.forEach((item: any) => {
        const body = {
          file: item,
          url: '',
        };
        const reader = new FileReader();
        reader.readAsDataURL(item); // read file as data url
        reader.onload = (event) => {
          // called once readAsDataURL is completed
          // @ts-ignore
          body.url = event.target?.result;
        };
        this.files.push(body);
      });
    }

    console.log(this.files);

    this.sendFile.emit(this.files.map((el) => el.file));
    this.sendFileWithId.emit(this.files.map((el) => ({file : el.file, id: el.id})));
  }

  getType(str: any): string {
    if (str?.split('/')[0] == 'image') {
      return str?.split('/')[0] + '-type';
    } else if (str?.split('/')[1] == 'pdf') {
      return str?.split('/')[1];
    } else {
      return 'doc';
    }
  }
  delete(i: number) {
    this.deleteFile.emit(i);
    this.files.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }
}
